import { combineReducers } from 'redux';

import { RegisterAction } from '../types';
import {
  resendRequest,
  resendSuccess,
  resendFail,
} from '../actions';

const loading = (state = false, action: RegisterAction) => {
  switch (action.type) {
    case resendRequest.type:
      return true;

    case resendSuccess.type:
    case resendFail.type:
      return false;

    default:
      return state;
  }
};

const error = (state: string | null = null, action: RegisterAction) => {
  switch (action.type) {
    case resendRequest.type:
    case resendSuccess.type:
      return null;

    case resendFail.type:
      return action.payload.message;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  error,
});
